$(document).ready(function(){

  var sliderBanner = $('.slider--banners');
  var sliderBannerSettings = {
    'arrows': false,
    'dots': true,
    'appendDots': $('.dotsNav'),
    'autoplay': true,
    'autoplaySpeed': 4000,
    'pauseOnHover': false,
  };
  sliderBanner.slick(sliderBannerSettings);

  var sliderGallery = $('.slider--gallery');
  var sliderGallerySettings = {
    'arrows': true,
    'dots': false,
    'rows': 2,
    'slidesToShow': 4,
    'slidesToScroll': 4,
    'infinite': false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        }
      }
    ]
  };
  sliderGallery.slick(sliderGallerySettings);

});